import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Typography } from '@totalsoft/rocket-ui';

const Header = ({ title }) => {
  const { t } = useTranslation();
  return (
    <Typography noWrap variant='subtitle1' fontWeight='bold' sx={{ pr: 0.5 }}>
      {title ? `${t('Questionnaire.Title')}: ${title}` : t('Questionnaire.Title')}
    </Typography>
  );
};

Header.propTypes = {
  title: PropTypes.string
};

export default Header;
